/**
 * Messages reducer
 *
 * @author Mamontov Andrey, 08/2018
 */
import * as messagesAction from '../actions/messages';

export const getError = (state: MessagesState) => state.error;
export const getSuccess = (state: MessagesState) => state.success;
export const getSystem = (state: MessagesState) => state.system;


export interface MessagesState {
  error: any;
  success: any;
  system: string; // for system messages
}

export const initialState: MessagesState = {
  error: null,
  success: null,
  system: null
};

export function reducer (state = initialState,
                         action: messagesAction.Action): any {
  switch (action.type) {
    case messagesAction.MESSAGE_SUCCESS: {
       return {
        ...state,
        success: action.payload,
        system: null
      };
    }
    case messagesAction.MESSAGE_ERROR: {
      return {
        ...state,
        error: action.payload,
        system: null
      };
    }
    case messagesAction.MESSAGE_SYSTEM: {
      return {
        ...state,
        system: action.payload,
      };
    }
    case messagesAction.MESSAGE_CLEAR_ALL: {
      return {
        ...state,
        success: null,
        error: null,
        system: null
      };
    }
    default:
      return state;
  }
}
